module.exports = __webpack_public_path__ + "img/RawaZaydan-MargiNadyar.6c53cc85.jpg";